import { RouterModule } from '@angular/router'
import { DataGenerationSectionComponent } from './data-generation-section.component'
import { CommonModule } from '@angular/common'
import { BrowserAnimationsModule } from '@angular/platform-browser/animations'
import { NgModule } from '@angular/core'
import { TranslateModule } from '@ngx-translate/core'
import { ContentEditableModule } from '@containers/i18n/content-editable/content-editable.module'
import { ReactiveFormsModule } from '@angular/forms'
import { SharedModule } from '@shared/shared.module'
import { LottieComponent } from 'ngx-lottie'

@NgModule({
  declarations: [DataGenerationSectionComponent],
  imports: [
    CommonModule,
    BrowserAnimationsModule,
    RouterModule,
    TranslateModule,
    ContentEditableModule,
    ReactiveFormsModule,
    SharedModule,
    LottieComponent,
  ],
  exports: [DataGenerationSectionComponent],
})
export class DataGenerationSectionModule {}
